import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class BankDetailsService extends Service {
	constructor(injector: Injector) {
		super("BankDetails", injector);
	}
}